import ApiService from "../ApiService";

const { REACT_APP_REST_ENDPOINT } = process.env;

export default class SafetyScadenzarioService {
    static list = (opts = {}) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/scadenzario/list`;
            ApiService.postRequest(resolve, reject, url, opts);
        });
    };

    static stats = (id_agenzia = "", giorni_anticipo = "") => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/scadenzario/stats`;
            const payload = {};
            if (id_agenzia) payload.id_agenzia = Number(id_agenzia);
            if (giorni_anticipo) payload.giorni_anticipo = Number(giorni_anticipo);
            ApiService.postRequest(resolve, reject, url, payload);
        });
    };

    static getConfig = (id_agenzia) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/scadenzario/config`;
            ApiService.postRequest(resolve, reject, url, { id_agenzia: Number(id_agenzia) });
        });
    };

    static saveConfig = (payload) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/scadenzario/saveConfig`;
            ApiService.postRequest(resolve, reject, url, payload);
        });
    };

    static inviaPromemoria = (id_agenzia) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/scadenzario/inviaPromemoria`;
            ApiService.postRequest(resolve, reject, url, { id_agenzia: Number(id_agenzia) });
        });
    };
}
